<template>
    <editor ref="configvaluesource" v-model="data"  @init="editorInit" :lang="currentLanguage" theme="monokai" width="100%"
                        height="400" style="font-size:15px;"></editor>
</template>

<script>
import Editor from 'vue2-ace-editor'

import {
    check_string_type,
    string_to_wrap
} from "@/utils/data_format_utils";

export default {
    data() {
        return {
            currentLanguage:'xml',
            data:''
        };
    },
    components:{
        Editor
    },
    methods:{
        editorInit() {
            // require('brace/ext/language_tools') //language extension prerequsite...
            require('brace/mode/xml')  
            require('brace/mode/json')                
            require('brace/mode/javascript')    //language
            require('brace/mode/less')
            require('brace/theme/monokai')
            require('brace/snippets/javascript') //snippet
        },
        handleWrapp(configvaluesource){
            this.currentLanguage = check_string_type(configvaluesource);
            this.data  = string_to_wrap(configvaluesource, this.currentLanguage);

        }
    }
};
</script>

<style lang="less" scoped>
</style>